// Sticky Add to Cart bar (snippets/sticky-add-to-cart.liquid). Shown once
// the visitor scrolls past the real #ProductForm [data-add-to-cart] button,
// kept in view until they scroll back above it.
//
// Deliberately does NOT reimplement cart-add logic: its own button is a
// pure proxy that clicks the real submit button, so pack-size resolution,
// volume pricing, and the document-level `submit` -> /cart/add.js handler
// in assets/cart-drawer.js stay the single source of truth. Price and
// availability are mirrored from the elements assets/product-form.js
// already updates via MutationObserver, never recomputed here. The variant
// label (pack size) is mirrored by listening to the same option-card
// `change` events product-form.js listens to, reading the currently
// checked values directly (product-form.js dispatches no custom event to
// hook into).
//
// 2026-09-29 (customer feedback): the thumbnail is now STATIC - rendered
// once by the liquid template from product.featured_image/locale override,
// deliberately no longer kept in sync with gallery/variant image swaps (it
// used to via MutationObserver on [data-gallery-image] - removed). The
// same-day dispatch cutoff countdown was removed entirely (was judged
// unnecessary clutter) - no countdown markup/logic here anymore.
(function () {
  var bar = document.querySelector('[data-sticky-add-to-cart]');
  var form = document.getElementById('ProductForm');
  if (!bar || !form) return;

  var realButton = form.querySelector('[data-add-to-cart]');
  if (!realButton) return;

  var stickyButton = bar.querySelector('[data-sticky-add-to-cart-button]');
  var stickyLabel = bar.querySelector('[data-sticky-add-to-cart-label]');
  var stickyPrice = bar.querySelector('[data-sticky-price]');
  var stickyVariantLabel = bar.querySelector('[data-sticky-variant-label]');
  var addLabel = bar.dataset.addLabel;
  var soldOutLabel = bar.dataset.soldOutLabel;

  // --- Show/hide on scroll past the real button ---------------------------
  // Also nudges the fixed WhatsApp widget (snippets/whatsapp-widget.liquid)
  // up out of the bar's way while it's visible - on narrow/mobile viewports
  // the two fixed-position elements occupy the same bottom-right corner and
  // would otherwise overlap/obscure the CTA (confirmed via preview: both
  // sit at the same z-40).
  var whatsappWidget = document.querySelector('[data-whatsapp-widget]');
  function shiftWhatsapp() {
    if (!whatsappWidget) return;
    window.requestAnimationFrame(function () {
      var barHeight = bar.getBoundingClientRect().height;
      whatsappWidget.style.transform = 'translateY(-' + (barHeight + 16) + 'px)';
    });
  }
  function resetWhatsapp() {
    if (!whatsappWidget) return;
    whatsappWidget.style.transform = '';
  }

  function showBar() {
    bar.classList.remove('translate-y-full', 'opacity-0', 'pointer-events-none');
    bar.setAttribute('aria-hidden', 'false');
    shiftWhatsapp();
  }
  function hideBar() {
    bar.classList.add('translate-y-full', 'opacity-0', 'pointer-events-none');
    bar.setAttribute('aria-hidden', 'true');
    resetWhatsapp();
  }

  // Visible once the real button has scrolled fully above the viewport.
  // IntersectionObserver alone misses jumps (a fast swipe, anchor links,
  // scroll restoration) that skip over the button without it ever crossing
  // the viewport edge, so a rAF-throttled scroll check backs it up.
  var barShown = false;
  function evaluateBar() {
    var shouldShow = realButton.getBoundingClientRect().bottom < 0;
    if (shouldShow === barShown) return;
    barShown = shouldShow;
    if (shouldShow) showBar(); else hideBar();
  }
  var evaluateQueued = false;
  function queueEvaluate() {
    if (evaluateQueued) return;
    evaluateQueued = true;
    window.requestAnimationFrame(function () {
      evaluateQueued = false;
      evaluateBar();
    });
  }
  window.addEventListener('scroll', queueEvaluate, { passive: true });
  window.addEventListener('resize', queueEvaluate);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(queueEvaluate, { threshold: 0 }).observe(realButton);
  }
  evaluateBar();

  // --- Proxy submit: clicking the sticky CTA submits the real form -------
  stickyButton.addEventListener('click', function () {
    if (realButton.disabled) return;
    realButton.click();
  });

  // --- Mirror price ---------------------------------------------------
  var priceEl = document.querySelector('[data-price]');
  if (priceEl && stickyPrice) {
    var syncPrice = function () {
      stickyPrice.textContent = priceEl.textContent;
    };
    syncPrice();
    new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  // --- Mirror selected variant label (pack size) ---------------------------
  var optionInputs = form.querySelectorAll('[data-option-position]');
  if (stickyVariantLabel && optionInputs.length) {
    var syncVariantLabel = function () {
      var checked = Array.prototype.filter.call(optionInputs, function (input) {
        return input.checked;
      });
      checked.sort(function (a, b) {
        return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
      });
      stickyVariantLabel.textContent = checked.map(function (input) {
        return input.value;
      }).join(' / ');
    };
    optionInputs.forEach(function (input) {
      input.addEventListener('change', syncVariantLabel);
    });
  }

  // --- Mirror add-to-cart availability/label -------------------------------
  var syncButtonState = function () {
    stickyButton.disabled = realButton.disabled;
    if (stickyLabel) {
      stickyLabel.textContent = realButton.disabled ? soldOutLabel : addLabel;
    }
  };
  syncButtonState();
  new MutationObserver(syncButtonState).observe(realButton, { attributes: true, attributeFilter: ['disabled'] });
})();
